/**
 * Login ekranındaki "Personel / Yönetici" sekmesinin hatırlanması.
 *
 * Sekme yalnızca bileşen state'inde tutulduğu için her yenilemede Personel'e
 * dönüyordu; kullanıcı sekmeyi tekrar tıklamayı unutunca yönetici hesabı bile
 * kursiyer panelinde açılıyordu. Panel girişin yapıldığı sekmeden belirlenir
 * (bkz. store.setUserFromToken): Kursiyer sekmesinden giren yönetici kursiyer
 * panelinde açılır. Seçim saklandığı için yenilemede sekme kaybolmaz.
 */
import { LoginRole, LoginStep } from "../constants/loginSteps"

const LOGIN_ROLE_STORAGE_KEY = "euas:login-role"

/** Son seçilen sekme; okunamazsa Personel. */
export const readStoredLoginRole = (): LoginRole => {
  try {
    const raw = window.localStorage.getItem(LOGIN_ROLE_STORAGE_KEY)
    return Number(raw) === LoginRole.MANAGER ? LoginRole.MANAGER : LoginRole.EMPLOYEE
  } catch {
    // Storage kapalı/kotası dolu: varsayılan sekmeyle devam edilir.
    return LoginRole.EMPLOYEE
  }
}

export const storeLoginRole = (role: LoginRole): void => {
  try {
    window.localStorage.setItem(LOGIN_ROLE_STORAGE_KEY, String(role))
  } catch {
    // Sekme hatırlanamaz; giriş akışı etkilenmez.
  }
}

/** Sekmenin karşılığı olan login adımı. */
export const stepForLoginRole = (role: LoginRole): LoginStep =>
  role === LoginRole.MANAGER ? LoginStep.ADMIN_LOGIN : LoginStep.STAFF_LOGIN
